import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import WarehouseService from '@iso/services/SettingsService/WarehouseService/WarehouseService';

function* viewWarehouse({ id }) {
    try {
        const response = yield call(WarehouseService.getOne, id);
        yield put(actions.viewWarehouseSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewWarehouseFailed(extractError(error)));
    }
}

function* watchViewWarehouse() {
    yield takeEvery(
        types.REQUEST_VIEW_WAREHOUSE,
        viewWarehouse,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewWarehouse),
    ]);
}

export default viewSaga;
